function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "768px",
    height: "389px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M -0.5,-0.5 C 57.5,-0.5 115.5,-0.5 173.5,-0.5C 89.8518,12.6452 34.3518,59.3119 7,139.5C 4.25955,151.894 1.75955,164.227 -0.5,176.5C -0.5,117.5 -0.5,58.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4099f6",
    d: "M 173.5,-0.5 C 183.167,-0.5 192.833,-0.5 202.5,-0.5C 268.132,4.95225 318.965,35.2856 355,90.5C 358.038,95.2432 360.538,100.243 362.5,105.5C 302.5,106.167 242.5,106.833 182.5,107.5C 150.128,112.596 126.962,129.929 113,159.5C 97.7944,200.512 106.628,235.345 139.5,264C 152.705,273.676 167.372,279.509 183.5,281.5C 243.331,282.499 303.331,282.832 363.5,282.5C 332.684,341.63 284.351,376.963 218.5,388.5C 201.5,388.5 184.5,388.5 167.5,388.5C 96.0146,376.525 45.1813,337.525 15,271.5C 6.70322,251.486 1.53656,230.819 -0.5,209.5C -0.5,198.5 -0.5,187.5 -0.5,176.5C 1.75955,164.227 4.25955,151.894 7,139.5C 34.3518,59.3119 89.8518,12.6452 173.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 202.5,-0.5 C 262.833,-0.5 323.167,-0.5 383.5,-0.5C 383.5,56.5 383.5,113.5 383.5,170.5C 380.456,148.367 373.789,127.367 363.5,107.5C 363.672,106.508 363.338,105.842 362.5,105.5C 360.538,100.243 358.038,95.2432 355,90.5C 318.965,35.2856 268.132,4.95225 202.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f16648",
    d: "M 383.5,-0.5 C 441.5,-0.5 499.5,-0.5 557.5,-0.5C 477.749,11.2684 423.249,54.6017 394,129.5C 389.615,145.099 386.115,160.766 383.5,176.5C 383.5,174.5 383.5,172.5 383.5,170.5C 383.5,113.5 383.5,56.5 383.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f196a0",
    d: "M 557.5,-0.5 C 567.167,-0.5 576.833,-0.5 586.5,-0.5C 662.037,6.84282 716.537,44.5095 750,112.5C 758.511,132.891 764.344,153.891 767.5,175.5C 767.5,185.5 767.5,195.5 767.5,205.5C 760.668,281.338 723.334,336.504 655.5,371C 633.67,380.623 611.003,386.457 587.5,388.5C 577.5,388.5 567.5,388.5 557.5,388.5C 485.325,378.485 433.159,340.819 401,275.5C 392.492,255.123 386.659,234.123 383.5,212.5C 384.754,200.491 384.754,188.491 383.5,176.5C 386.115,160.766 389.615,145.099 394,129.5C 423.249,54.6017 477.749,11.2684 557.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f16648",
    d: "M 586.5,-0.5 C 646.833,-0.5 707.167,-0.5 767.5,-0.5C 767.5,58.1667 767.5,116.833 767.5,175.5C 764.344,153.891 758.511,132.891 750,112.5C 716.537,44.5095 662.037,6.84282 586.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6caff7",
    d: "M 362.5,105.5 C 363.338,105.842 363.672,106.508 363.5,107.5C 311.331,107.168 259.331,107.501 207.5,108.5C 199.195,107.668 190.862,107.335 182.5,107.5C 242.5,106.833 302.5,106.167 362.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 182.5,107.5 C 190.862,107.335 199.195,107.668 207.5,108.5C 245.203,117.37 268.37,140.703 277,178.5C 281.982,223.714 264.149,256.214 223.5,276C 218.293,278.014 212.96,279.514 207.5,280.5C 199.542,281.403 191.542,281.736 183.5,281.5C 167.372,279.509 152.705,273.676 139.5,264C 106.628,235.345 97.7944,200.512 113,159.5C 126.962,129.929 150.128,112.596 182.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4099f5",
    d: "M 207.5,108.5 C 259.331,107.501 311.331,107.168 363.5,107.5C 373.789,127.367 380.456,148.367 383.5,170.5C 383.5,172.5 383.5,174.5 383.5,176.5C 384.754,188.491 384.754,200.491 383.5,212.5C 383.5,214.167 383.5,215.833 383.5,217.5C 380.824,239.866 374.491,261.199 364.5,281.5C 311.997,281.832 259.664,281.499 207.5,280.5C 212.96,279.514 218.293,278.014 223.5,276C 264.149,256.214 281.982,223.714 277,178.5C 268.37,140.703 245.203,117.37 207.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M -0.5,209.5 C 1.53656,230.819 6.70322,251.486 15,271.5C 45.1813,337.525 96.0146,376.525 167.5,388.5C 111.5,388.5 55.5,388.5 -0.5,388.5C -0.5,328.833 -0.5,269.167 -0.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f16648",
    d: "M 383.5,212.5 C 386.659,234.123 392.492,255.123 401,275.5C 433.159,340.819 485.325,378.485 557.5,388.5C 499.5,388.5 441.5,388.5 383.5,388.5C 383.5,331.5 383.5,274.5 383.5,217.5C 383.5,215.833 383.5,214.167 383.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f16648",
    d: "M 767.5,205.5 C 767.5,266.5 767.5,327.5 767.5,388.5C 707.5,388.5 647.5,388.5 587.5,388.5C 611.003,386.457 633.67,380.623 655.5,371C 723.334,336.504 760.668,281.338 767.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 383.5,217.5 C 383.5,274.5 383.5,331.5 383.5,388.5C 328.5,388.5 273.5,388.5 218.5,388.5C 284.351,376.963 332.684,341.63 363.5,282.5C 364.167,282.5 364.5,282.167 364.5,281.5C 374.491,261.199 380.824,239.866 383.5,217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6aaef7",
    d: "M 207.5,280.5 C 259.664,281.499 311.997,281.832 364.5,281.5C 364.5,282.167 364.167,282.5 363.5,282.5C 303.331,282.832 243.331,282.499 183.5,281.5C 191.542,281.736 199.542,281.403 207.5,280.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightbot);
export default __webpack_public_path__ + "static/media/rightbot.44d259118d7dfd4d0404ad3694e5c691.svg";
export { ForwardRef as ReactComponent };